import { useCallback, useEffect, useState } from 'react';
import { getBiosenseErrorInfo } from '../utils/biosenseErrorCodes';

const useError = (alert) => {
  const [errorMessage, setErrorMessage] = useState<string>();

  const displayError = useCallback((message: string) => {
    setErrorMessage(message);
  }, []);

  useEffect(() => {
    if (alert?.code === -1) {
      setErrorMessage('');
      return;
    }

    if (alert?.code) {
      const info = getBiosenseErrorInfo(alert.code);
      if (info) {
        displayError(`${info?.cause} (Code: ${info.code})`);
      } else {
        displayError(`Please ensure good lighting, stable internet, and try again. (Code: ${alert.code})`);
      }
    }
  }, [alert]);

  return errorMessage;
};
export default useError;
